class Util {
  // constructor() {}
  truncateFileName = (n, len = 30) => {
    var ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
    var filename = n.replace("." + ext, "");
    if (filename.length <= len) {
      return n;
    }
    filename = filename.substr(0, len) + (n.length > len ? "..." : "");
    return filename + "." + ext;
  };

  openClosePanel = (indicator, documents, doc) => {
    const index = documents.indexOf(doc);
    const position = indicator.indexOf(index);
    if (position > -1) {
      indicator.splice(position, 1);
      doc.Expaned = false;
    } else {
      indicator.push(index);
      doc.Expaned = true;
    }
  };

  convertToDateObj = dateString => {
    const parts = dateString.split(" ");
    const dateParts = parts[0].split(".");
    const timeParts = parts[1].split(":");
    return new Date(
      dateParts[2],
      dateParts[1] - 1,
      dateParts[0],
      timeParts[0],
      timeParts[1],
      timeParts[2]
    );
  };
}

const utl = new Util();
export default utl;
